import { PaymentRequest } from "@/models/api/PaymentRequest";
import { PaymentInitResult } from "@/models/www/PaymentInitResult";
import { PayResult } from "@/models/www/PayResult";
import paymentService from "@/services/payment.service";
import { useBookingStore } from "@/store/booking";

const usePayment = () => {
	const { getBooking } = useBookingStore();

	const prepareForPayment = (): Promise<PaymentInitResult> => {
		return paymentService.init();
	}

	const startPayment = (payload: any): Promise<PayResult> => {
		return paymentService.start({
			merchantKey: payload.merchantKey,
			cardIdentifier: payload.cardIdentifier,
			bookingNumber: getBooking.bookingNumber,
			terms: true,
			browserLanguage: payload.browserLanguage,
			javaEnabled: payload.javaEnabled,
			colorDepth: payload.colorDepth,
			remoteIP: payload.remoteIP,
			screenHeight: payload.screenHeight,
			screenWidth: payload.screenWidth,
			timeZone: payload.timeZone,
			windowSize: payload.windowSize
		} as PaymentRequest);
	}
	
	const validateCard = (cardNumber: string) : Promise<boolean> => {
			return paymentService.validateCard(cardNumber);
	}

	return { prepareForPayment, startPayment, validateCard }
}

export default usePayment;